const getTransitionStyles = timeout => {
  return {
    entering: {
      opacity: 0,
      transform: 'translateY(1%)'
    },
    entered: {
      transition: `opacity calc(${timeout}ms * 2) ease-out, transform calc(${timeout}ms * 2) ease-out`,
      opacity: 1
    },
    exiting: {
      transition: `opacity ${timeout}ms ease-in, transform ${timeout}ms ease-in`,
      opacity: 0,
      transform: 'translateY(-1%)'
    }
  };
};

const getTransitionStyle = ({ timeout, status }) => getTransitionStyles(timeout)[status];

export default getTransitionStyle;



// WEBPACK FOOTER //
// ./src/utils/getTransitionStyle.js